<template>
  <div>
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          Shipment Pay Statement No：{{
            formData.shipmentPayStatementNo || 'New'
          }}
        </span>
        <el-divider
          direction="vertical"
          v-if="formData.shipmentPayStatementStatus"
        ></el-divider>
        <b-badge
          v-if="formData.shipmentPayStatementStatus"
          style="font-size: 12px"
          :variant="
            formData.shipmentPayStatementStatus === 'W'
              ? 'primary'
              : formData.shipmentPayStatementStatus === 'S'
              ? 'success'
              : formData.shipmentPayStatementStatus === 'D'
              ? 'danger'
              : formData.shipmentPayStatementStatus === 'R'
              ? 'warning'
              : ''
          "
        >
          {{ formData.v_shipmentPayStatementStatus }}
        </b-badge>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Update：{{ formData.modifyByName || '--' }} at
          {{ formData.modifyTime || '--' }}
        </span>
      </div>
    </div>
    <el-form ref="form" :model="formData" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_shipmentContractNo') || '外运编号'"
          >
            <el-input v-model="formData.shipmentContractNo" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_shipmentNo') || '发运单编号'">
            <el-input v-model="formData.shipmentNo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_customer') || '客户'">
            <el-input v-model="formData.custName" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item :label="$l('form_label_partyType') || '结算方类型'">
            <el-input v-model="formData.v_payTo" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_party') || '结算方'">
            <el-input v-model="formData.payScmName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="$l('form_label_payer') || '付款方'">
            <el-input v-model="formData.payerName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$l('form_label_currencyTotalAmount') || '费用合计'"
          >
            <el-input v-model="v_currencyTotalAmount" readonly> </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payScmBankName') || '结算方开户银行'"
          >
            <el-input v-model="formData.payScmBankName" readonly> </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payScmBankAccountName') || '结算方账户名称'"
          >
            <el-input v-model="formData.payScmBankAccountName" readonly>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_payScmBankAccountNo') || '结算方银行账号'"
          >
            <el-input v-model="formData.payScmBankAccountNo" readonly>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="16">
          <el-form-item :label="$l('form_label_remark') || '账单说明'">
            <el-input
              v-model="formData.remark"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              maxlength="30"
              show-word-limit
              readonly
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <ItemTable ref="itemTable" :tableData="formData.listItem" />
      </el-row>
      <el-row>
        <DocTable ref="docTable" :tableData="formData.listDoc" />
      </el-row>
    </el-form>
  </div>
</template>
<script>
import ItemTable from '../item-table'
import DocTable from '../doc-table'
export default {
  components: { ItemTable, DocTable },
  props: {
    shipmentPayStatementCode: { type: String, default: '' },
    shipmentPayStatementStatus: { type: String, default: '' },
  },
  data() {
    return {
      formData: { currencyTotalAmount: 0 },
    }
  },
  computed: {
    v_currencyTotalAmount() {
      const { currencyTotalAmount } = this.formData
      return !currencyTotalAmount ? '' : currencyTotalAmount.toLocaleString()
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.shipmentPayStatementCode) return
      this.$api
        .shipmentPayStatementDetailApi({
          shipmentPayStatementCode: this.shipmentPayStatementCode,
        })
        .then((res) => {
          this.formData = res.body
          const { shipmentPayStatementStatus } = this.formData
          this.$emit(
            'update:shipmentPayStatementStatus',
            shipmentPayStatementStatus
          )
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
.side-frame-warning {
  padding: 1px 5px;
  border-left: 3px solid $color-warning;
  height: 20px;
  margin-top: 3px;
}
</style>
